<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import { computed, ComputedRef, onMounted, ref } from 'vue';

    // utils
    import { uid } from '@utils';

    // assets
    import { SmallArrowDownSVG, SmallArrowUpSVG } from '@shared/assets/vector/ui/IconsUI';

    // this is mostly for debugging, otherwise components are Anonymous
    export default {
        name: 'Input_Depr',
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            value: any;
            mod?: number;
            placeholder?: string;
            type?: string;
            id?: string;
        }>(),
        {}
    );
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <input class="fluid-input" type="text" :value="value" :placeholder="placeholder" :id="id" @input="$emit('update:value', ($event.target as any).value)" />
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .section-group .fluid-input {
        margin-bottom: 0.85rem;
    }

    .fluid-input {
        font-size: 0.7rem;
        color: #2d3729;
        display: block;
        position: relative;
        height: 1.7rem;
        width: 100%;
        padding: 0.2rem 0.3rem;
        margin: 0.3rem 0;
        border: 0.05rem solid #97cdc6;

        border-radius: 0.2rem;
        outline: none;
    }
    .fluid-input::placeholder {
        opacity: 0.6;
    }

    .fluid-input.subheading {
        height: 1.9rem;
    }

    .fluid-input.small {
        height: 1.2rem;
        font-size: 0.7rem;
    }

    .fluid-input.subheading.minimal {
        font-size: 1rem;
    }
    .fluid-input.minimal {
        color: var(--clr-mirage);
        width: 100%;
        padding: 0.2rem 0;
        margin-top: 0;
        border: none;
        border-bottom: 1px solid #c3c0c0;
        border-radius: 0;
        background-color: transparent;
        box-shadow: none;

        transition-property: border, background-color, color, padding;
        transition-duration: var(--td-faster);
        transition-timing-function: ease;
    }

    .fluid-input.minimal:hover {
        color: #362f3d;
        border-color: var(--clr-easter-blue);
    }
    .fluid-input.minimal:focus {
        color: #1b171f;
        padding: 0.2rem 0.3rem;
        border-color: var(--clr-gunpowder);
        background-color: #fff;
    }

    .fluid-input.minimal.light {
        color: #cabbbb;
        border-color: #554e5b1f;
    }
    .fluid-input.minimal.light:hover,
    .fluid-input.minimal.light:focus {
        color: #eee8e8;
        border-color: #554e5b;
        background-color: transparent;
    }
</style>
